import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react';

const styles = {
  warning: {
    wrapper: 'bg-orange-50 border-orange-200 text-orange-800',
    icon: AlertTriangle,
    iconClass: 'text-orange-500',
  },
  error: {
    wrapper: 'bg-red-50 border-red-200 text-red-800',
    icon: XCircle,
    iconClass: 'text-red-500',
  },
  info: {
    wrapper: 'bg-blue-50 border-blue-200 text-blue-800',
    icon: Info,
    iconClass: 'text-blue-500',
  },
  success: {
    wrapper: 'bg-green-50 border-green-200 text-green-800',
    icon: CheckCircle,
    iconClass: 'text-green-500',
  },
};

export default function AlertBanner({ type = 'warning', message, href, onDismiss }) {
  const navigate = useNavigate();
  const s = styles[type] ?? styles.warning;
  const Icon = s.icon;

  return (
    <div
      className={`flex items-center gap-3 rounded-lg border px-4 py-3 text-sm ${s.wrapper} ${href ? 'cursor-pointer hover:opacity-90 transition-opacity' : ''}`}
      role="alert"
      onClick={href ? () => navigate(href) : undefined}
    >
      <Icon size={18} className={`shrink-0 ${s.iconClass}`} aria-hidden />
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button
          onClick={(e) => { e.stopPropagation(); onDismiss(); }}
          className="shrink-0 opacity-60 hover:opacity-100"
          aria-label="Fermer l'alerte"
        >
          <XCircle size={16} />
        </button>
      )}
    </div>
  );
}
